<template>
  <div class="video-wrapper">
    <div id="local_video" class="zb-video" style="object-fit: cover;"></div>
	<playSvga ref="svga" v-if="show_svga"/>
  </div>
</template>

<script>
import { getChatRoomDetails } from "@/api/zhibo";
import playSvga from "../playSvga/playSvga.vue";
export default {
  components: {
    playSvga
  },
  data() {
    return {
	  livePusher:null,
	  audioEffectManager:null,
	  data:'',
	  show_svga:true
    };
  },
  mounted() {
	this.getLivePusher()
	
  },
  methods: {
	getLivePusher(data){
		const quality = data?data:'720p'
		this.livePusher = new TXLivePusher();
		this.audioEffectManager  = this.livePusher.getAudioEffectManager()
		this.livePusher.setRenderView('local_video');
		this.livePusher.videoView.muted = true;
		// 设置视频质量
		this.livePusher.setVideoQuality(quality);
		// 设置音频质量
		this.livePusher.setAudioQuality('standard');
		// 自定义设置帧率
		this.livePusher.setProperty('setVideoFPS', 25);
		// 打开摄像头
		this.livePusher.startCamera();
		// 打开麦克风
		this.livePusher.startMicrophone();
		if(this.$route.query.liveId && this.$store.state.liveId){
			this.getChatRoomDetails()
		}
	},
	//开始推流
	startPush(){
		const pushUrl = this.data.chatRoomDetails.pushUrl
		setTimeout(v=>{
			this.livePusher.startPush(pushUrl)
		},1000)
	},
	//设置画质
	setVideoQuality(data){
		this.livePusher.destroy()
		this.livePusher = null
		const quality = data===0?'720p':'360p'
		this.getLivePusher(quality)
	},
	//直播间详情
	async getChatRoomDetails(){
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
		this.data = res.data
		this.startPush()
	},
	//设置音量
	setVolume(data){
		console.log(data)
		this.audioEffectManager.setVolume(data)
	},
	//播放礼物
	addGiftToQueue(data){
		console.log(data,123)
		this.$refs.svga.addGiftToQueue(data)
	},
	//显示或者关闭特效
	showSvga(data){
		this.show_svga = data
	}
	
  },
  beforeDestroy() {
	this.livePusher.stopCamera();
	this.livePusher.stopMicrophone();
	this.livePusher.stopPush();
  	this.livePusher.destroy()
	this.livePusher = null
	console.log('停止采集')
  }
};
</script>
<style scoped lang="scss">
	@import "./tengxunyunzb.css";
</style>


// WEBPACK FOOTER //
// tengxunyunzb.vue?f38ae6e2